import React from 'react';
import {
  Area,
  AreaChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { t } from '../../../utils/i18n';
import {
  CHART_AXIS_STROKE,
  CHART_GRID_STROKE,
  CHART_HEIGHT,
  CHART_PRIMARY,
  darkChartTooltipProps,
  formatChartDate,
} from '../../../utils/gaDashboard';
import DashboardPanel from '../components/DashboardPanel';
import ChartSkeleton from '../components/ChartSkeleton';

export default function GaUserActivityChart({ data, isLoading, className = '' }) {
  return (
    <DashboardPanel title={t('dashboard.ga.charts.userActivity')} className={className}>
      {isLoading ? (
        <ChartSkeleton heightClass={CHART_HEIGHT.wide} />
      ) : !data?.length ? (
        <p
          className={`${CHART_HEIGHT.wide} flex items-center justify-center text-dark-text-secondary`}
        >
          {t('dashboard.ga.noData')}
        </p>
      ) : (
        <div className={`${CHART_HEIGHT.wide} animate-fade-in`}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="dauAreaFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={CHART_PRIMARY} stopOpacity={0.3} />
                  <stop offset="100%" stopColor={CHART_PRIMARY} stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_STROKE} />
              <XAxis
                dataKey="date"
                stroke={CHART_AXIS_STROKE}
                fontSize={11}
                tickFormatter={formatChartDate}
              />
              <YAxis stroke={CHART_AXIS_STROKE} fontSize={11} width={32} />
              <Tooltip {...darkChartTooltipProps} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Area
                type="monotone"
                dataKey="dau"
                name={t('dashboard.ga.kpi.dau')}
                stroke={CHART_PRIMARY}
                strokeWidth={1.75}
                fill="url(#dauAreaFill)"
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="wau"
                name={t('dashboard.ga.kpi.wau')}
                stroke="rgb(var(--admin-chart-green))"
                strokeWidth={1.75}
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="mau"
                name={t('dashboard.ga.kpi.mau')}
                stroke="rgb(var(--admin-chart-blue))"
                strokeWidth={1.75}
                dot={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </DashboardPanel>
  );
}
